import React, { useState,useEffect } from 'react';
import { Button } from 'primereact/button'; 

const UploadFileItem = ({ file, onRemove, index }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
  
    useEffect(() => {
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        return () => {
          URL.revokeObjectURL(url);
        };
      }
    }, [file]);
  
    const isImage = file.type.startsWith('image/');
  
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "5px 0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {isImage && previewUrl ? (
            <img src={previewUrl} alt={file.name} style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }} />
          ) : (
            <i className="pi pi-file" style={{ fontSize: '1.5em' }}></i>
          )}
          <div>
            <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>{file.name}</div>
            <div style={{ fontSize: '0.8rem', color: '#666' }}>{Math.round(file.size / 1024)} KB</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ fontSize: '0.75rem', backgroundColor: '#f0ad4e', color: 'white', padding: '2px 6px', borderRadius: '5px' }}>
            Aguardando confirmação
          </span>
          <Button
            type="button"
            icon="pi pi-times"
            className="p-button-danger p-button-text"
            onClick={() => onRemove(index)}
            style={{ padding: "0.3rem", height: "2rem", width: "2rem" }}
          />
        </div>
      </div>
    );
  };
  
  export default UploadFileItem;
  